import React from 'react'
import { ReactECharts } from './Echarts'
import { isPDFGenerationModeEnabled } from '../../lib/utils/isPDFGenerationModeEnabled'

type Props = {
  data: {
    stage1: {
      label: string
      value: number
    }
    stage2: {
      label: string
      value: number
    }
    stage3: {
      label: string
      value: number
    }
    stage4: {
      label: string
      value: number
    }
  }
  isLoading?: boolean
  isPreviousData: boolean
  hasDMS?: boolean
}
const disableAnimations = isPDFGenerationModeEnabled()
  ? {
      animation: false,
    }
  : {
      animation: true,
    }
const FunnelChart = ({ data, isLoading, isPreviousData, hasDMS }: Props) => {
  // Create chart data with appropriate conditions
  const getChartData = () => {
    const baseData = [
      {
        value: data?.stage1.value,
        name: data?.stage1.label,
        itemStyle: {
          color: {
            type: 'linear' as const,
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0.14,
                color: '#70EC8C',
              },
              {
                offset: 0.86,
                color: 'rgba(6, 210, 238, 0.5)',
              },
            ],
          },
        },
      },
      {
        value: data?.stage2?.value,
        name: data?.stage2?.label,
        itemStyle: {
          color: {
            type: 'linear' as const,
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#FFC0AC',
              },
              {
                offset: 1,
                color: '#F2709C',
              },
            ],
          },
        },
      },
      {
        value: data?.stage3?.value,
        name: data?.stage3?.label,
        itemStyle: {
          color: {
            type: 'linear' as const,
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#D6BBFF',
              },
              {
                offset: 1,
                color: '#4776E6 ',
              },
            ],
          },
        },
      },
    ]

    // Only add stage 4 if we shouldn't show the connect DMS CTA
    if (hasDMS) {
      baseData.push({
        value: data?.stage4?.value,
        name: data?.stage4?.label,
        itemStyle: {
          color: {
            type: 'linear' as const,
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(255, 247, 51, 0.5)',
              },
              {
                offset: 1,
                color: 'rgba(255, 201, 12, 0.5)',
              },
            ],
          },
        },
      })
    }

    return baseData
  }

  const chartData = getChartData()

  return (
    <ReactECharts
      loading={isLoading || isPreviousData}
      option={{
        textStyle: {
          fontFamily: 'Spartan',
        },

        series: [
          {
            gap: 8,
            orient: 'horizontal',
            type: 'funnel',
            left: '1%',
            width: '98%',
            minSize: isLoading ? '0%' : '35%',
            maxSize: '100%',
            min: data?.stage4.value,
            max: isLoading ? -1 : data.stage2.value * 2,
            ...disableAnimations,
            sort: 'none',
            label: {
              show: true,
              position: 'inside',
              formatter: function (params) {
                const formattedValue = new Intl.NumberFormat('en-US').format(
                  params.value as number,
                )
                return [
                  '{light|' + params.name + '}',
                  '{value|' + formattedValue + '}',
                ].join('\n')
              },
              color: '#121124',
              rich: {
                light: {
                  fontWeight: 'normal',
                  fontFamily: 'Spartan',
                  fontSize: 16,
                  lineHeight: 20,
                  color: '#121124',
                  verticalAlign: 'top',
                  textBorderColor: 'transparent', // set the text border color to transparent
                  textBorderWidth: 0, // set the text border width to 0
                },
                value: {
                  fontWeight: 'bold',
                  fontFamily: 'Spartan',
                  fontSize: 20,
                  lineHeight: 24,
                  color: '#121124',
                  verticalAlign: 'bottom',
                  textBorderColor: 'transparent', // set the text border color to transparent
                  textBorderWidth: 0, // set the text border width to 0
                },
              },
            },
            data: chartData,
          },
        ],
      }}
    />
  )
}
export default FunnelChart
